export default class CiiVoyageData {
    constructor(startDate, endDate, loadingCondition, voyageNumber, voyageLeg) {
        this.startDate = startDate
        this.endDate = endDate
        this.loadingCondition = loadingCondition
        this.voyageNumber = voyageNumber
        this.voyageLeg = voyageLeg
    }

    get shortLoadingCondition() {
        if (this.loadingCondition && this.loadingCondition.length > 1) {
            return this.loadingCondition.substring(0, 1)
        }
        return this.loadingCondition
    }

    get startDateTimestamp() {
        return new Date(this.startDate).getTime();
    }

    get endDateTimestamp() {
        return new Date(this.endDate).getTime();
    }
}